import React, { useEffect, useState } from 'react'
import { GeoTopCities } from '../../../services'
import { MapPin, Building2 } from 'lucide-react'

function TopCities() {
  const [topCities, setTopCities] = useState([])
  const [loading, setLoading] = useState(true)

  const fetchTopCities = async () => {
    try {
      setLoading(true)
      const res = await GeoTopCities()
      setTopCities(res)
    } catch (error) {
      console.error('Error fetching activity logs:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchTopCities()
  }, [])

  if (loading) {
    return (
      <div className="bg-white rounded-lg shadow-md p-6 mb-6">
        <div className="animate-pulse">
          <div className="h-6 bg-gray-200 rounded w-1/3 mb-4"></div>
          <div className="space-y-3">
            {[1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="h-16 bg-gray-200 rounded"></div>
            ))}
          </div>
        </div>
      </div>
    )
  }

  const maxCount = Math.max(...topCities.map(item => item.count || 0), 1)

  return (
    <div className="bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 p-6 mb-6 border border-gray-100">
      <div className="flex items-center mb-6">
        <div className="bg-gradient-to-r from-indigo-500 to-purple-500 p-3 rounded-lg mr-4">
          <Building2 className="w-6 h-6 text-white" />
        </div>
        <div>
          <h2 className="text-xl font-bold text-gray-800">Top Cities</h2>
          <p className="text-sm text-gray-500">Most active cities worldwide</p>
        </div>
      </div>

      {topCities.length === 0 ? (
        <div className="text-center py-12">
          <div className="bg-gray-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
            <MapPin className="w-8 h-8 text-gray-400" />
          </div>
          <p className="text-gray-500">No city data found</p>
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b-2 border-gray-200">
                <th className="text-left py-3 px-2 text-xs font-semibold text-gray-600 uppercase">Rank</th>
                <th className="text-left py-3 px-2 text-xs font-semibold text-gray-600 uppercase">City</th>
                <th className="text-left py-3 px-2 text-xs font-semibold text-gray-600 uppercase">Country</th>
                <th className="text-right py-3 px-2 text-xs font-semibold text-gray-600 uppercase">Activities</th>
                <th className="text-left py-3 px-2 text-xs font-semibold text-gray-600 uppercase">Distribution</th>
              </tr>
            </thead>
            <tbody>
              {topCities.map((item, index) => {
                const widthPercent = ((item.count / maxCount) * 100).toFixed(1)
                
                return (
                  <tr key={index} className="border-b border-gray-100 hover:bg-gray-50 transition-colors">
                    <td className="py-3 px-2">
                      <div className="flex items-center justify-center w-8 h-8 rounded-full bg-indigo-100 text-indigo-600 font-bold text-sm">
                        {index + 1}
                      </div>
                    </td>
                    <td className="py-3 px-2">
                      <div className="flex items-center space-x-2">
                        <MapPin className="w-4 h-4 text-indigo-500" />
                        <span className="font-medium text-gray-800">{item.city || 'Unknown'}</span>
                      </div>
                    </td>
                    <td className="py-3 px-2">
                      <span className="text-sm text-gray-600">{item.country || 'Unknown'}</span>
                    </td>
                    <td className="py-3 px-2 text-right">
                      <span className="text-lg font-bold text-gray-800">
                        {item.count?.toLocaleString() || 0}
                      </span>
                    </td>
                    <td className="py-3 px-2">
                      <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
                        <div
                          className="bg-gradient-to-r from-indigo-500 to-purple-500 h-full rounded-full transition-all duration-500"
                          style={{ width: `${widthPercent}%` }}
                        ></div>
                      </div>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      )}

      {topCities.length > 0 && (
        <div className="mt-6 pt-4 border-t border-gray-200">
          <div className="flex items-center justify-between text-sm">
            <span className="text-gray-500">Total Cities Tracked</span>
            <span className="text-lg font-bold text-gray-800">{topCities.length}</span>
          </div>
        </div>
      )}
    </div>
  )
}

export default TopCities